export const VALIDATE_OTP_CODE_START = 'VALIDATE_OTP_CODE_START';

export const VALIDATE_OTP_CODE_SUCCESS = 'VALIDATE_OTP_CODE_SUCCESS';

export const VALIDATE_OTP_CODE_FAILURE = 'VALIDATE_OTP_CODE_FAILURE';

export const CLEAR_VALIDATE_OTP_CODE_ERROR_MESSAGE = 'CLEAR_OTP_CODE_ERROR_MESSAGE';
